/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;text-align:center}mat-dialog-actions[_ngcontent-%COMP%]{display:block}[mat-button][_ngcontent-%COMP%]{padding:0}hr[_ngcontent-%COMP%]{margin:auto -24px}"];
export { styles as styles };
